import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import { BaseBackResponse } from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.marketplace}tickets`;

export interface TrackTicketActivityCommandArgs {
  ticketId: string;
  userId: string;
}

export const trackTicketActivityRequest = (
  payload: TrackTicketActivityCommandArgs,
): ApiRequestDescriptor => ({
  url: `${ENDPOINT}/${payload.ticketId}`,
  config: { method: SUPPORTED_METHODS.PUT, json: { userId: payload.userId } },
});

export const trackTicketActivityCommand = async (
  payload: TrackTicketActivityCommandArgs,
): Promise<BaseBackResponse> => {
  try {
    return await executeQuery<BaseBackResponse>(
      trackTicketActivityRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
